// extracted by mini-css-extract-plugin
export default {"container":"Sankey_container__5AIib","tabelas":"Sankey_tabelas__cOyh5","table":"Sankey_table__hbNw6","invert":"Sankey_invert__2BZQQ"};